import { useQuery } from '@tanstack/react-query'
import { authorizedFetch } from '@/lib/api'

export interface ObservabilityStatus {
  langsmith: {
    connected: boolean
    project?: string | null
    trace_count?: number | null
    run_count?: number | null
    external_url?: string | null
    sink_enabled?: boolean
  }
}

export function useObservabilityStatus() {
  return useQuery({
    queryKey: ['admin', 'observability', 'status'],
    queryFn: async (): Promise<ObservabilityStatus> => {
      const response = await authorizedFetch('/api/admin/observability/status')
      if (!response.ok) {
        const text = await response.text()
        throw new Error(text || `Failed to load observability status (${response.status})`)
      }
      return response.json()
    },
    staleTime: 60_000,
  })
}
